var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"f-l-r m-r-10",attrs:{"type":"success","id":"details2"}},[_vm._v("在线咨询")])}
var staticRenderFns = []

export { render, staticRenderFns }